import styled from "styled-components";
import mixins from "../../../styles/mixins";
import CircleProgress from "../molecules/CircleProgress";
import ProgressBar from "../molecules/ProgressBar";

const Container = styled.div`
    & ~ & {
        margin-top: 30px;
    }
    

    .word-list {
        margin-top: 8px;
        dl {
            display: flex;
            align-items: center;
            gap: 0 8px;
            dt {
                font-size: 10px;
                line-height: 14px;
                letter-spacing: -0.03em;
                color: rgba(132, 132, 132, 1);
                white-space: nowrap;
            }
            dd {
                ${mixins.caption}
                color: rgba(64, 64, 70, 1);
            }
        }
    }
`;
const Wrap = styled.section`
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
`;
const Top = styled.div`
    display: flex;
    gap: 0 20px;
    .title {
        .h2 {
            display: flex;
            align-items: center;
            > span {
                ${mixins.body3}
                color: rgba(132, 132, 132, 1);
                margin-left: 4px;
            }
        }
    }

    .data-wrap {
        margin-top: 4px;
        display: flex;
        gap: 4px 0;
        width: 100%;
        padding-top: 14px;

        .text-cont, .graph-cont {
            display: flex;
            flex-direction: column;
            gap: 4px 0;
        }
        
        .graph-cont {
            flex-grow: 1;
            position: relative;
            .graph-label {
                display: flex;
                justify-content: space-between;
                align-self: flex-end;
                width: 100%;
                padding-right: 48px;
                position: absolute;
                right: 0;
                top: 0;
                transform: translateY(-100%);

                span {
                    ${mixins.caption}
                    color: rgba(132, 132, 132, 1);
                }
            }
        }
    }

    .text-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-width: 92px;
        height: 22px;

        .label {
            white-space: nowrap;
            min-width: 60px;
            margin-right: 4px;
            ${mixins.body2}
        }

        .report-badge {
            white-space: nowrap;
            ${mixins.body3}
            margin-right: 10px;
        }
    }

    .graph-wrap {
        display: flex;
        align-items: center;
        height: 22px;
        gap: 0 10px;
        padding-right: 19px;
    }
`;
const Bottom = styled.div`
    position: relative;
    background-color: rgba(225, 242, 237, 0.6);
    padding: 16px;
    overflow: hidden;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

    &::before {
        content: "";
        display: block;
        width: 378px;
        height: 66px;
        position: absolute;
        top: 0;
        left: 0;
        background-image: url(${process.env.PUBLIC_URL}/image/img_report_bg_skin_state_top.png);
    }
    &::after {
        content: "";
        display: block;
        width: 347px;
        height: 66px;
        position: absolute;
        bottom: 0;
        right: 0;
        background-image: url(${process.env.PUBLIC_URL}/image/img_report_bg_skin_state_bottom.png);
    }

    p {
        position: relative;
        z-index: 1;
        ${mixins.body3}
        color: rgba(64, 64, 70, 1);
    }
`

export default function SkinStateInfo({type, caption, description, score, minLabel="", maxLabel="", item}) {
    return (
        <Container>
            <Wrap>
                <Top>
                    <div>
                        <CircleProgress value={score} />
                    </div>
                    <div className="flex-grow-1">
                        <div className="title">
                            <div className="h2">
                                {type} <span>({caption})</span>
                            </div>
                        </div>


                        <div className="data-wrap">
                            <div className="text-cont">
                            {
                                item.map(el => {
                                    return (
                                            <div className="text-wrap">
                                                <div className="label">{el.label}</div>
                                                <div className="report-badge">{el.level}</div>
                                            </div>
                                    )
                                })
                            }
                            </div>
                            <div className="graph-cont">
                                
                                <div className="graph-label">
                                    <span>{minLabel}(0)</span>
                                    <span>{maxLabel}(100)</span>
                                </div>

                                {
                                    item.map(el => {
                                        return (
                                            <div className="graph-wrap">
                                                <ProgressBar value={el.value} type="square"/>
                                                <span className="score">{el.value}</span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </Top>

            </Wrap>
            <Bottom>
                <p>
                    {description}
                </p>
            </Bottom>

            <div className="word-list">
                {
                    item.map(el => {
                        return (
                            <dl>
                                <dt>{el.label}</dt>
                                <dd>{el.description}</dd>
                            </dl>   
                        )
                    })
                }
            </div>
        </Container>
    )
}